<template>
  <div class="previousReserveCar">
    <h4 class="col-md-2 previousReserveCar__title">前派預約叫車：</h4>
    <div class="col-md-10">
      <div class="row previousReserveCar__rowContainer">
        <label
          for="passengerName"
          class="col-md-2 previousReserveCar__subtitle"
        >
          選擇派單方式：
        </label>
        <div class="col-md-2">
          <select
            id="hailing-call-reserve-method"
            v-model="takeOrderType"
            class="previousReserveCar__select"
          >
            <option value="grab">直接搶單</option>
            <option value="designation">指定派單</option>
            <!-- <option value="application">多人應徵</option> -->
          </select>
        </div>
        <div class="col-md-6" v-if="takeOrderType === 'designation'">
          <label
            for="passengerName"
            class="col-md-3 previousReserveCar__subtitle"
          >
            司機指定呼號
          </label>
          <input
            type="text"
            class="col-md-3 previousReserveCar__inputField"
            placeholder="司機呼號"
            v-model="call_number_first"
          />
        </div>
      </div>
      <div class="row previousReserveCar__rowContainer">
        <h4 class="col-md-2 previousReserveCar__subtitle">上車時間：</h4>
        <date-select
          ref="reservationTime"
          @week-data="getWeekchange"
          class="col-md-7"
        ></date-select>
        <h4 class="col-md-2 previousReserveCar__subtitle">({{ week }})</h4>
      </div>
      <div class="row previousReserveCar__rowContainer">
        <h4 class="col-md-4 previousReserveCar__subtitle">
          上車地點：{{ onLocation }}
        </h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          下車地點：{{ offLocation }}
        </h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          乘客服務備註：{{ noteAndServiceList }}
        </h4>
      </div>
      <div class="row previousReserveCar__rowContainer">
        <h4 class="col-md-4 previousReserveCar__subtitle">名稱：{{ name }}</h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          電話：{{ customerPhone }}
        </h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          乘客數：{{ userNumber }}
        </h4>
      </div>
      <div class="row previousReserveCar__rowContainer">
        <h4 class="col-md-4 previousReserveCar__subtitle">
          簽單地點：{{ enterpriseOnLocation }}>{{ enterpriseOffLocation }}
        </h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          簽單備註：{{ enterpriseNote }}
        </h4>
        <h4 class="col-md-4 previousReserveCar__subtitle">
          金額：{{ enterpriseAmount }}
        </h4>
      </div>
      <div class="row previousReserveCar__rowContainer">
        <div class="col-sm-2">
          <label class="previousReserveCar__subtitle">
            <input
              type="checkbox"
              class="previousReserveCar__checkbox"
              v-model="checkedLimit"
            />
            限制範圍
          </label>
        </div>
        <div class="col-sm-2">
          <select
            class="col-md-12 previousReserveCar__select"
            :class="{ non_selected: !checkedLimit }"
            v-model="distance"
          >
            <option value="3000">三公里內</option>
            <option value="5000">五公里內</option>
            <option value="8000">八公里內</option>
          </select>
        </div>
      </div>
      <div
        class="row previousReserveCar__rowContainer previousReserveCar__rowContainer--buttons"
      >
        <BaseButton
          class="previousReserveCar__button previousReserveCar__button--reservePage"
          :text="'前往預約單頁面'"
          :backgroundColor="'#ec971f'"
          :textColor="'#FFF'"
          @click="changePage"
        />
        <BaseButton
          class="previousReserveCar__button previousReserveCar__button--submit"
          :text="'送出前派單'"
          :backgroundColor="'#337ab7'"
          :textColor="'#FFF'"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DateSelect from './tool/DateSelectNonLimit'
import BaseButton from '@/components/common/button/BaseButton'
import { isTimeInvalid } from '@/assets/js/tool/timeUtils'

export default {
  props: [
    'onLocation',
    'offLocation',
    'passengerNote',
    'contactPhone',
    'customerPhone',
    'name',
    'onlng',
    'onlat',
    'offlng',
    'offlat',
    'userNumber',
    'serviceList',
    'selectedList',
    'cars',
    'blackList',
    'enterpriseOnLocation',
    'enterpriseOffLocation',
    'enterpriseAmount',
    'enterpriseNote',
  ],
  components: {
    BaseButton,
    DateSelect,
  },
  data() {
    return {
      takeOrderType: 'grab',
      call_number_first: '',
      call_number_second: '',
      call_number_third: '',
      reservationTime: '',
      week: '',
      distance: 8000,
      checkedLimit: false,
    }
  },
  methods: {
    getWeekchange(val) {
      // console.log(val)
      this.$set(this, 'week', val)
    },
    changePage() {
      this.$router.push({ name: 'ReservationList' })
    },
    resettingTime() {
      this.$refs.reservationTime.resetTime()
    },
    resetting() {
      this.takeOrderType = 'grab'
      this.call_number_first = ''
      this.call_number_second = ''
      this.call_number_third = ''
      this.checkedLimit = false
      this.resettingTime()
    },
    checkReservation(payload) {
      if (payload.onLocation === null || payload.onLocation === '') {
        this.$msg('請輸入上車地點')
        return false
      }
      if (payload.contactPhone === null || payload.contactPhone === '') {
        this.$msg('請輸入電話')
        return false
      }
      if (payload.name === null || payload.name === '') {
        this.$msg('請輸入名稱')
        return false
      }
      if (payload.onlng === null || payload.onlng === '') {
        this.$msg('請輸入上車地點')
        return false
      }
      if (isTimeInvalid(payload.reservationTime)) {
        this.$msg('輸入日期錯誤')

        return false
      }
      return true
    },
    submit() {
      this.reservationTime = this.$refs.reservationTime.getDate()
      if (this.isSubmit) return this.$msg('已發送一次')
      this.reservationSubmit()
    },
    getWeek() {
      this.week = this.$refs.reservationTime.getWeek()
    },
    reservationSubmit() {
      let callNumberList = []
      let reservation = {
        onLocation: this.onLocation,
        offLocation: this.offLocation,
        passengerNote: this.passengerNote,
        contactPhone: this.contactPhone,
        customerPhone: this.customerPhone,
        name: this.name,
        onlng: this.onlng,
        onlat: this.onlat,
        offlng: this.offlng,
        offlat: this.offlat,
        takeOrderType: this.takeOrderType,
        userNumber: this.userNumber,
        reservationTime: this.reservationTime,
        service_list: this.serviceList,
        selectedList: this.selectedList,
        cars: this.cars,
        checkedLimit: this.checkedLimit,
        distance: this.distance,
        blackList: this.blackList,
        enterpriseOnLocation: this.enterpriseOnLocation,
        enterpriseOffLocation: this.enterpriseOffLocation,
        enterpriseAmount: this.enterpriseAmount,
        enterpriseNote: this.enterpriseNote,
      }
      if (this.call_number_first !== '')
        callNumberList.push(this.call_number_first)
      if (this.call_number_second !== '')
        callNumberList.push(this.call_number_second)
      if (this.call_number_third !== '')
        callNumberList.push(this.call_number_third)
      reservation.callNumberList = callNumberList
      if (this.takeOrderType === 'designation') {
        if (reservation.callNumberList.length === 0) {
          this.$msg('請輸入指定司機')
          return
        }
      }
      if (!this.checkReservation(reservation)) {
        return
      }
      this.$emit('openReservationModal', reservation)
    },
  },
  mounted() {
    this.getWeek()
  },
  computed: {
    noteAndServiceList() {
      if (this.passengerNote === null && this.selectedList === null) {
        return ''
      }
      if (this.passengerNote === null) {
        return this.selectedList
      }
      if (this.selectedList === undefined || this.selectedList === null) {
        return this.passengerNote
      }
      return this.passengerNote + ',' + this.selectedList
    },
  },
}
</script>
<style lang="scss" scoped>
.previousReserveCar {
  &__rowContainer {
    min-height: 45px;
    display: flex;
    align-items: center;

    &--buttons {
      justify-content: flex-end;
    }
  }
  &__title {
    padding-left: 15px;
    font-size: 18px;
    color: black;
    margin: 0;
    height: 36px;
    line-height: 36px;
  }
  &__subtitle {
    font-size: 16px;
    color: black;
    margin: 0;
    min-height: 36px;
    line-height: 36px;
  }
  &__button {
    height: 36px;
    margin: 0;
    margin-left: 10px;
    outline: none;

    &--submit {
      width: 135px;
    }
    &--reservePage {
      width: 140px;
    }
  }

  &__inputField {
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__select {
    width: 100%;
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__checkbox {
    zoom: 150%;
    margin: 0;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PreviousReserveCar.vue